import { DEFAULT_RATING_REGION } from '../constants/locations';
import { prepareSeoParams } from '../server/helpers/prepareSeoParams';
import type { TFilters } from '../types/filters';

export const makeSeoParams = (filters: TFilters) =>
  prepareSeoParams({
    filters: {
      ...filters,
      location: filters.location || DEFAULT_RATING_REGION,
    },
  });
